import { Grid } from "@mui/material";
import CustomSelect from "../../../../../../../../components/CustomSelect";
import Input from "../../../../../../../../components/Input";
import { PatientVital } from "../../../../../../../../services";
import { OXYGEN_OPTS, VitalFormik } from "../vital-constant";

interface OxygenFieldsProps {
  formik: VitalFormik;
  ind: number;
}

const OxygenFields = ({ formik, ind }: OxygenFieldsProps) => {
  const activeVital =
    ind !== -1 ? formik.values?.patientVitals?.[ind] : undefined;

  const isSelected = activeVital?.selected ?? false;

  const getKey = (k: keyof PatientVital) => `patientVitals.${ind}.${k}`;

  const getError = (key: keyof PatientVital) => {
    const touched = (formik.touched.patientVitals as any)?.[ind]?.[key];
    const error = (formik.errors.patientVitals as any)?.[ind]?.[key];
    return touched && error ? String(error) : undefined;
  };

  const selectHandleChange = (k: keyof PatientVital, v: string | null) => {
    formik.setFieldValue(getKey(k), v);
  };

  return (
    <Grid container gap={2}>
      <Grid xs={1.8}>
        <Input
          required={isSelected}
          error={getError("value")}
          textFieldProps={{
            name: getKey("value"),
            placeholder: "91%",
            value: activeVital?.value,
            onChange: formik.handleChange,
            onBlur: formik.handleBlur,
          }}
        />
      </Grid>
      <Grid xs={2.6}>
        <CustomSelect
          name={getKey("method")}
          placeholder="Oxygen"
          options={OXYGEN_OPTS}
          value={activeVital?.method}
          onChange={(v) => selectHandleChange("method", v)}
        />
      </Grid>
    </Grid>
  );
};

export default OxygenFields;
